import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import cloneDeep from 'lodash.clonedeep';
import initialState from '..';
import formatDate from '../../../utils/formatDate'; // -------------------------------------------------
// CONSTANTS
// -------------------------------------------------

export var GET_GLOBAL_ITEMS = 'GET_GLOBAL_ITEMS';
var GET_GLOBAL_ITEMS_REQUEST = 'GET_GLOBAL_ITEMS_REQUEST';
var GET_GLOBAL_ITEMS_SUCCESS = 'GET_GLOBAL_ITEMS_SUCCESS';
var GET_GLOBAL_ITEMS_FAILURE = 'GET_GLOBAL_ITEMS_FAILURE'; // -------------------------------------------------
// ACTIONS
// -------------------------------------------------

export var getGlobalItems = function getGlobalItems() {
  var requestQuery = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    query: ''
  };
  return {
    type: GET_GLOBAL_ITEMS,
    requestQuery: requestQuery
  };
};
export var getGlobalItemsRequest = function getGlobalItemsRequest() {
  return {
    type: GET_GLOBAL_ITEMS_REQUEST
  };
};
export var getGlobalItemsSuccess = function getGlobalItemsSuccess(payload) {
  return {
    type: GET_GLOBAL_ITEMS_SUCCESS,
    payload: payload
  };
};
export var getGlobalItemsFailure = function getGlobalItemsFailure(error) {
  return {
    type: GET_GLOBAL_ITEMS_FAILURE,
    error: error
  };
}; // -------------------------------------------------
// REDUCER
// -------------------------------------------------

export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var newState = cloneDeep(state);

  switch (action.type) {
    case GET_GLOBAL_ITEMS_REQUEST:
      newState.ui.isRequesting = true;
      newState.ui.isUpdating = false;
      newState.error = null;
      return newState;

    case GET_GLOBAL_ITEMS_SUCCESS:
      newState.ui.isRequesting = false;
      newState.ui.isUpdating = false;
      newState.error = action.payload.errors ? action.payload.errors[0].message : null;
      newState.data.wishlists = action.payload.data.wishlists || newState.data.wishlists;

      if (action.payload.data.wishlists) {
        newState.data.wishlists[0].items = newState.data.wishlists[0].items.map(function (item) {
          return item.dateAdded ? _objectSpread(_objectSpread({}, item), {}, {
            displayDate: formatDate(item.dateAdded)
          }) : _objectSpread({}, item);
        });
      }

      return newState;

    case GET_GLOBAL_ITEMS_FAILURE:
      newState.ui.isRequesting = false;
      newState.ui.isUpdating = false;
      newState.error = action.error.message;
      return newState;

    default:
      return state;
  }
});